import Tooltip from "@/shared/data-display/tooltip";
import Button from "@/shared/form/button";
import Text from "@/shared/typography/text";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useErrorWatcher } from "../utils/use-error-watcher";

export function ErrorsTooltip({ name }: { name: string | string[] }) {
  const { errors } = useErrorWatcher({ name });

  if (errors.length === 0) {
    return null;
  }

  return (
    <Tooltip title={<Text>{errors}</Text>} color="white" placement="right">
      <Button danger type="primary" icon={<ExclamationCircleOutlined />} />
    </Tooltip>
  );
}
